export default __webpack_public_path__ + "static/media/HARD.adece328.png";